import type { LandingCampaign } from '@/types/landing'
import { buildParticipantThemeCss } from '@/lib/participant-theme'

export function ParticipantThemeStyle({
  campaign,
}: {
  campaign?: LandingCampaign | null
}) {
  return (
    <style>
      {buildParticipantThemeCss(
        campaign ?? {
          primary_color: null,
          secondary_color: null,
          button_color: null,
          highlight_color: null,
        }
      )}
    </style>
  )
}
